import millify from "millify";
import Loader from 'elements/Loader'
import RowItem from "components/shareable/RowItem";
import { makeKey } from "modules/Utils";

interface GeographiesStatsProps {
    className: string;
    shown: boolean;
    geographiesBreakdown: any
}
export default function GeographiesDetails({
    className,
    shown,
    geographiesBreakdown
}: GeographiesStatsProps) {

    return (
        <div className={`geographiesDetailsComponent ${className} ${shown ? 'visible' : 'hidden'}`}>
            {!geographiesBreakdown ?
                <Loader
                    className="geographiesLoaderPreSave"
                    title="Loading data..."
                    style={{
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    }}
                />
                :
                <div>
                    <ul className="max-h-80 overflow-auto">
                        {
                            geographiesBreakdown
                                .map((item: {
                                    country: string,
                                    state: string,
                                    city: string,
                                    count: number,
                                }, index: number) => {
                                    const name = (item.city) ? `${item.city}, ${item.country}` : item.country;
                                    return (
                                        <RowItem
                                            key={makeKey(name, index)}
                                            imageStyles={`h-6`}
                                            name={name}
                                            showRightValue={true}
                                            rightValue={`${millify(item.count)}`}
                                        />
                                    );
                                })
                        }
                    </ul>
                </div>
            }
        </div>

    )
}